<template>
  <div class="md-layout" v-if="role == 'gym'">
    <div class="md-layout-item md-size-100">
      <div class="md-card">
        <div class="md-card-header md-card-header-icon md-card-header-rose">
          <div class="card-icon">
            <i class="material-icons">payments</i>
          </div>
          <h4 class="title">{{ $t("settings") }}</h4>
        </div>
        <div class="md-card-content">
          <div class="md-layout">
            <div class="w-100 p-2 card">
              <label class="md-form-label text-primary">{{
                $t("waitingPeriod")
              }}</label>
              <small>({{ $t("waitingPeriodExplanation") }})</small>

              <div class="md-field">
                <select class="md-select" v-model="settings_waitingDays">
                  <option value="1">1 día</option>
                  <option value="2">2 días</option>
                  <option value="3">3 días</option>
                  <option value="4">4 días</option>
                  <option value="5">5 días</option>
                  <option value="6">6 días</option>
                  <option value="7">7 días</option>
                  <option value="8">8 días</option>
                  <option value="9">9 días</option>
                  <option value="10">10 días</option>
                </select>
              </div>
            </div>

            <div class="float-left w-100 mt-3 p-2 card">
              <div class="md-field mt-0 p-0">
                <input type="checkbox" v-model="settings_sendReminderEmail" class="mt-0">
                <span class="text-primary">Enviar un email de recordatorio</span>
              </div>
              <small
                >Se enviará un email de recordatorio cuando se acerca la fecha
                de pago y cuando hay retraso en el pago.</small
              >
              <small
                >(Se enviará solo a aquellos clientes que tengan una solicitud
                de pago en estado pendiente) </small
              ><small class="text-primary">
                <router-link to="/myorders"
                  >Ver solicitudes de pago</router-link
                ></small
              >
            </div>

            <div class="float-left w-100 mt-3 p-2 card">
              <div class="md-field mt-0 p-0">
                <input type="checkbox" v-model="settings_register" class="mt-0">
                <span class="text-primary">Permitir auto registro</span>
              </div>
              <small> {{ $t("selfRegistrationMessage") }}</small>
              <small>({{ $t("gotakeitUsageMessage") }})</small>
            </div>

            <div class="float-left w-100 mt-3 p-2 card">
              <div class="md-field mt-0 p-0">
                <input type="checkbox" v-model="settings_access" class="mt-0">
                <span class="text-primary">Habilitar botón de acceso</span>
              </div>
              <small
                >Si habilitas este botón, tus clientes podrán marcar el ingreso
                al establecimiento haciendo click en un boton "MARCAR INGRESO"
                sin necesidad de escanear un QR. Con este método no necesitas
                imprimir un QR pero al mismo tiempo debes confiar que tus
                clientes haran click en el boton al llegar al establecimiento y
                no en cualquier momento desde su casa por ejemplo.</small
              >
            </div>

            <div class="float-left w-100 mt-4">
              <div class="w-100 p-2">
                <h6>
                  Elije de que manera quieres que el sistema cobre a tus
                  clientes
                </h6>
              </div>
              <div class="w-100 card p-2">
                <div class="md-field mt-0 p-0">
                  <input type="checkbox" v-model="settings_mercadopago" class="mt-0">
                  <span class="text-primary">Con Mercado Pago:</span>
                  <img
                    width="30px"
                    class="d-inline mercadopago"
                    :src="mercadopago"
                  />
                </div>
                <small
                  >Si elijes esta opción el sistema generará una suscripcion
                  directa de tu cuenta de Mercado Pago con debito automático a
                  tus clientes. Cuando el cliente pague, el sistema marcara ese
                  mes como "Pagado"</small
                >
                <div class="w-100" v-if="settings_mercadopago">
                  <div>
                    <button
                      class="md-button md-raised md-primary"
                      @click="conectarMercadoPago()"
                      :disabled="isLoading || mp_client"
                    >
                      Sincronizar con Mercado Pago
                      <div class="loading-container mr-2" v-if="isLoading">
                        <div
                          class="spinner-border spinner-border-sm text-secondary mr-2"
                          role="status"
                        >
                        </div>
                      </div>
                    </button>
                  </div>
                  <div v-if="mp_client" class="text-success w-100 mb-4">
                    <i class="material-icons text-success">check</i>
                    Ya estás sincronizado.
                    <div
                      class="md-layout-item md-size-100 p-2 w-100 float-left"
                    >
                      <div class="w-100 float-left">
                        <small class="pt-2 text-secondary"
                          >Los clientes al conectarse en su cuenta verán un
                          boton "PAGAR" con el monto a pagar que tu definas en
                          el listado de clientes.</small
                        >
                      </div>
                    </div>
                    <div class="w-100 float-left">
                      <button
                        class="md-button md-raised md-danger"
                        @click="unSync()"
                        :disabled="isLoading"
                      >
                        Desincronizar <i class="material-icons">link_off</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 p-2 card mt-4">
                <div class="md-field mt-2 p-0">
                  <input type="checkbox" v-model="settings_paymentLink" class="mt-0">
                  <span class="text-primary">Con Link o transferencia bancaria:</span>
                </div>
                <small>
                  El sistema le pedirá a tu cliente que pague a través del link
                  de pago o cualquier cuenta bancaria que tu prefieras.</small
                >

                <div class="md-field mt-2 p-0" v-if="settings_paymentLink">
                  <label>Link de pago, CVU, Alias...</label>
                  <input class="md-input" v-model="settings_paymentInfo" type="text" placeholder="Subir comprobante:">
                </div>

                <div class="md-field mt-4 p-0" v-if="settings_paymentLink">
                  <input type="checkbox" v-model="settings_uploadRecipt" class="mt-0">
                  <span>Marcar como pagado automáticamente:</span>
                </div>
                <small v-if="settings_paymentLink"
                  >El sistema le pedirá a tu cliente que suba el comprobante de
                  pago, cuando el cliente lo suba, el sistema marcara el mes
                  como "pagado". Luego podrás verificar los comprobantes en el
                  listado de clientes opción "comprobantes" para chequear que
                  sean correctos</small
                >
              </div>
            </div>

            <div class="md-layout mt-4">
              <div class="md-layout-item md-size-50">
                <button class="md-button md-raised md-primary" @click="saveSettings">{{
                  $t("save")
                }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAction, getSettingsAction } from "@/pages/Auth/actions";

import {
  hasMercadoPagoAction,
  removeMercadoPagoAction,
  unSyncAction,
} from "@/pages/MercadoPago/actions";
import permissionsMixin from "@/mixins/permissionsMixin";
import Swal from "sweetalert2";

export default {
  mixins: [permissionsMixin],
  data() {
    return {
      settings: {
        register: true,
        waitingDays: 10,
      },
      mercadopago: process.env.BASE_URL + "img/mercado-pago.png",
      mp_client: false,
      isLoading: false, // Estado de carga
      authorizationCode: null, // Código de autorización devuelto por Mercado Pago
      role: false,
      nameBusiness: "",
      emailBusiness: "",
      useredit: false,
      subdomain: "",
      currencyOptions: [],
      settings_paymentLink: "",
      settings_waitingDays: 10,
      settings_mercadopago: false,
      settings_register: false,
      settings_access: false,
      settings_paymentInfo: "",
      settings_uploadRecipt: false,
      settings_sendReminderEmail: false,
    };
  },
  created() {
    this.role = localStorage.getItem("role");

    this.hasMercadoPago();
  },
  methods: {
    async hasMercadoPago() {
      const result = await hasMercadoPagoAction();
      if (result.data) {
        this.mp_client = result.data;
      }
    },
    async fetchBusinessData() {
      try {
        const response = await getSettingsAction();
        const data = response.result;
        this.emailBusiness =
          data.email === "contact@rodisio.com" ? "" : data.email || "";
        this.nameBusiness = data.name || "";

        this.settings_paymentLink = data.paymentLink;
        this.settings_waitingDays = data.waitingDays;
        this.settings_mercadopago = data.mercadoPago;
        this.settings_register = data.register;
        this.settings_access = data.accessButton;
        this.settings_paymentInfo = data.paymentInfo;
        this.settings_uploadRecipt = data.uploadRecipt;
        this.settings_sendReminderEmail = data.sendReminderEmail;
      } catch (error) {
        console.error("Error fetching business data:", error);
      }
    },

    async saveSettings() {
      if (this.isDemo()) {
        return;
      }
      try {
        const data = {
          paymentLink: this.settings_paymentLink,
          waitingDays: this.settings_waitingDays,
          mercadoPago: this.settings_mercadopago,
          register: this.settings_register,
          accessButton: this.settings_access,
          paymentInfo: this.settings_paymentInfo,
          uploadRecipt: this.settings_uploadRecipt,
          sendReminderEmail: this.settings_sendReminderEmail,
        };

        await saveAction(data);
        Swal.fire({
          title: this.$tn("success"),
          text: this.$tn("business_info_updated"),
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error("Error saving business data:", error);
        Swal.fire({
          title: this.$tn("error"),
          text: this.$tn("error_updating_business_info"),
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },

    async unSync() {
      const result = await unSyncAction();
      this.mp_client = null;
    },

    async conectarMercadoPago() {
      this.isLoading = true;

      const subdomain = window.location.hostname.split(".")[0];

      // URL de autorización de Mercado Pago con parámetros
      const clientId = process.env.VUE_APP_MP_CLIENT_ID_OAUTH; // Aquí va tu client_id de Mercado Pago
      const redirectUri = encodeURIComponent(
        "https://app.gotake.it/mercadopago/oauth"
      ); // Cambia a tu URL de redirección configurada
      const state = subdomain + "-" + Date.now(); // Opcional: un parámetro state para evitar CSRF
      localStorage.setItem("mercadoapagooauth", state);
      const scope = encodeURIComponent("offline_access read write"); // Scopes correctos, sin duplicación

      // Construir la URL de autorización
      const authorizationUrl = `https://auth.mercadopago.com.ar/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`;

      // Redirigir al usuario a la URL de autorización
      window.location.href = authorizationUrl;

      this.isLoading = false;
    },
    // Método para extraer el "authorization_code" de la URL cuando el cliente vuelva de Mercado Pago
    obtenerAuthorizationCode() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code"); // Obtener el "code" de la URL
      if (code) {
        this.authorizationCode = code; // Guardar el código de autorización
        // Aquí puedes enviar el código a tu backend para intercambiarlo por un access token
      }
    },
  },
  mounted() {
    // Cuando el componente se monte, intenta obtener el authorization_code si está presente
    this.obtenerAuthorizationCode();

    this.fetchBusinessData();
  },
};
</script>

<style scoped>
.mercadopago {
  background: #00bcff;
  width: 30px;
  height: 30px;
  border-radius: 7px;
}
.loading-container {
  display: inline-block;
}
</style>
